initAdapt()

/**
 * Initial function
 */
function initAdapt() {
    const container = document.querySelector('.header__menu-nav')

    /**
     * If markup not found just exit
     */
    if ( ! container ) {
        return
    }

    const primary = document.querySelector('.header__menu:not(._secondary)')

    primary.insertAdjacentHTML('beforeend', `
        <li class="_more">
            <button
                class="btn btn__menu-more"
                type="button"
                title="Показать скрытые пункты меню"
                aria-haspopup="true"
                aria-expanded="false">Еще</button>
            <ul class="header__menu _secondary list-unstyled">
                ${primary.innerHTML}
            </ul>
      </li>
    `)

    const secondary = container.querySelector('.header__menu._secondary')
    const moreLi = primary.querySelector('._more')
    const moreBtn = moreLi.querySelector('.btn__menu-more')

    /**
     * Show submenu on click
     */
    moreBtn.addEventListener('click', (e) => {
        e.preventDefault()
        container.classList.toggle('_show-secondary')
        moreBtn.setAttribute('aria-expanded', container.classList.contains('__show-secondary'))
    })

    /**
     * adapt immediately on load
     */
    doAdapt({ container, primary, secondary, moreBtn, moreLi })

    /**
     * adapt on window resize
     */
    window.addEventListener('resize', function() {
        doAdapt({ container, primary, secondary, moreBtn, moreLi })
    })

    /**
     * hide Secondary on the outside click
     */
    document.addEventListener('click', (e) => {
        let el = e.target
        while(el) {
            if(el === secondary || el === moreBtn) {
                return;
            }
            el = el.parentNode
        }
        container.classList.remove('_show-secondary')
        moreBtn.setAttribute('aria-expanded', false)
    })
}

/**
 * Adaptation function
 * @param container
 * @param primary
 * @param secondary
 * @param moreBtn
 * @param moreLi
 */
function doAdapt({ container, primary, secondary, moreBtn, moreLi }) {
    const primaryItems = container.querySelectorAll('.header__menu > li:not(._more)')
    const secondaryItems = secondary.querySelectorAll('li')
    const allItems = container.querySelectorAll('li')

    /**
     * Reveal all items for the calculation
     */
    allItems.forEach((item) => {
        item.classList.remove('_hidden')
    })

    /**
     * Hide items that won't fit in the Primary
     * @type {number}
     */
    let stopWidth = moreBtn.offsetWidth
    let hiddenItems = []
    const primaryWidth = primary.offsetWidth

    primaryItems.forEach((item, i) => {
        if(primaryWidth >= stopWidth + item.offsetWidth) {
            stopWidth += item.offsetWidth
        } else {
            item.classList.add('_hidden')
            hiddenItems.push(i)
        }
    })

    /**
     * Toggle the visibility of More button and items in Secondary
     */
    if ( ! hiddenItems.length ) {
        moreLi.classList.add('_hidden')
        container.classList.remove('_show-secondary')
        moreBtn.setAttribute('aria-expanded', false)
    } else {
        secondaryItems.forEach((item, i) => {
            if ( ! hiddenItems.includes(i) ) {
                item.classList.add('_hidden')
            }
        })
    }
}
